<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="EstablishmentTheReserveOfYearsOfService"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content">
    <editable-grid
      #grid
      *ngIf="gridColumns && gridColumns.length > 0"
      [columns]="gridColumns"
      [DefaultValues]="DefaultValues"
      [isAdd]="false"
      (afterSaved)="_save($event)"
      [isDelete]="false"
      [(dataList)]="dataList">
    </editable-grid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="icon-Takenote"
      buttontype="button"
      (click)="setData()"
      class="login-btn"
      tooltip="بازخوانی"
      appearance="mini-btn"
      class="btnfooter">
    </ssg-button>
  </ng-container>
</dynamic-form>
